import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcSave = ({ size, color }) => {
  return (
    <Icon
      className="IcSave material-icons-outlined tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      save
    </Icon>
  )
}

IcSave.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
}

export default IcSave
